import { VisibilityCheckParams } from '../types/clientCategory';

export function isReportVisible({
  visibility,
  category,
  requiredSubscription,
  clientSubscriptions,
}: VisibilityCheckParams): boolean {
  if (!visibility[category]) {
    return false;
  }

  if (requiredSubscription) {
    return clientSubscriptions.includes(requiredSubscription);
  }

  return true;
}
